/* eslint-disable no-undef */
// EN 客户端的工具(包含：app 和 pc)

// 判断是否为en5pc
export function isInEnPC() {
  if (!EASY_ENV_IS_BROWSER) {
    return false;
  }

  let isEnPC = false;
  try {
    if (
      window.CefSharp ||
      (window.external && window.external.GetUserAgent && window.external.GetUserAgent())
    ) {
      isEnPC = true;
    }
  } catch (error) {
    isEnPC = false;
  }

  return isEnPC;
}
